import { useState } from 'react'
import { SubscribeModal } from '@/components/modal'
import { useHasAllRequiredEntitlements } from '@/hooks/useHasActiveSubscription'
import { CMButton } from '../ui'

type Props = {
  /** The server's credit/subscription message, already display-formatted by the caller. */
  message: string
}

/**
 * Paywall shown when a live action preview BLOCKS for a credit/subscription reason — the coach is
 * out of complimentary credits or needs a DUPR+ / Premium Coach membership. It replaces the plain
 * error banner with an upgrade CTA that reuses the app's existing RevenueCat subscribe flow
 * ({@link SubscribeModal}). If the coach already holds the required entitlement, we surface the
 * message without an upsell — they are simply out of credits, not un-subscribed.
 */
export const CoachCreditPaywall = ({ message }: Props) => {
  const [showSubscribe, setShowSubscribe] = useState(false)
  // No specific entitlement group is carried on the preview, so fall back to the app's PREMIUM
  // check: a coach who already has DUPR+ but is out of credits sees the message without a CTA.
  const hasSubscription = useHasAllRequiredEntitlements(null)

  return (
    <div className="mt-3 rounded-lg border border-primary-200 bg-primary-50 px-3 py-3">
      <p className="text-sm font-semibold text-primary-800">DUPR+ required</p>
      <p className="mt-1 text-xs leading-snug text-primary-700">{message}</p>
      {!hasSubscription && (
        <div className="mt-2.5">
          <CMButton variant="primary" size="sm" onClick={() => setShowSubscribe(true)}>
            Subscribe to DUPR+
          </CMButton>
        </div>
      )}
      <SubscribeModal open={showSubscribe} onClose={() => setShowSubscribe(false)} />
    </div>
  )
}
